export default "__VITE_ASSET__Cc30gnad__"